import React, { useEffect } from "react";
import PropTypes from "prop-types";
import PrepareIndividualAlbum from './prepare_individual_album';
import useScrollRef from "../../../hooks/albums/use_scroll";
import {getAlbumThumnailSize} from "../meta/selectors";
import IConstants from "../meta/constants"
/* global photoOrg */

const prepareMonthWiseMySharedAlbumsList = function(data) {
    try {
        console.log(data);
        const albumList = {};
        let prevAlbumYear = "";
        for (let index in data) {
            let isFav = false;
            let val = data[index];
            for (let index=0; index < val.systemTags.length;index++) {
                let obj = val.systemTags[index];
                if (obj.key === "isFavorite" && obj.value === true) {
                    isFav = true;
                }
            }
            const isNotOwner = val.accessLevel !== "OWNER" ? true : false;

            if (isFav || isNotOwner) {
                continue;
            }
            
            let albumCreateDate = (val.createDate == null) ? new Date(val.updateDate) : new Date(val.createDate)
            
            const key = albumCreateDate.getMonth() + "_" + albumCreateDate.getFullYear();
            
            if (!(key in albumList)) {
                prevAlbumYear = albumCreateDate.getFullYear();
                albumList[key] = [];
                albumList[key].push(val);
            } else if (prevAlbumYear === albumCreateDate.getFullYear() && albumList.hasOwnProperty(key)) {
                //group for same date
                albumList[key].push(val);
            }
        }
        console.log("albumList=",albumList);
        return albumList;
    } catch (e) {
        photoOrg.clientLogger.error({description: "LIBRARY:albums_view:prepareMonthWiseMySharedAlbumsList:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack});
    }
}

const prepareMonthWiseAlbumList = function(data,shouldLoadprevious) {
    try {
        var albumList = {};
        var albumMap = data;
        var totalMonthSize = Object.keys(albumMap).length;
        for (var i = 0; i < totalMonthSize; i++) {

            var clusterDate;
            if (shouldLoadprevious === true) {
                clusterDate = Object.keys(albumMap)[totalMonthSize - (i + 1)];
            }
            else
                clusterDate = Object.keys(albumMap)[i];
            var key = clusterDate;
            
            key = clusterDate.split("-")
            key = key[1] - 1 + "_" + key[0];

            var val = albumMap[clusterDate]
            if (!(key in albumList))
                albumList[key] = [];
            albumList[key] = albumList[key].concat(val);
        }
        return albumList
    } catch (e) {
        photoOrg.clientLogger.error({description: "LIBRARY:OwnedAlbumsView:prepareMonthWiseAlbumList:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
    }
}

const IterateAndGenerateAlbumDom = ({selectionOnwedAlbumsRes, selectionSharedAlbumsRes, accessType, currentPageno}) => {

    try{
        useEffect(()=>{
            if (photoOrg.saveAlbumDetails && Object.keys(photoOrg.saveAlbumDetails).length != 0) {
                document.dispatchEvent(new CustomEvent("rjumpToAlbumsMonth", {
                  detail: {
                    albumId: photoOrg.saveAlbumDetails.saveAlbumId,
                    pageNo: photoOrg.saveAlbumDetails.pageNo,
                    date: photoOrg.saveAlbumDetails.date,
                    response: selectionOnwedAlbumsRes
                  }
                }));
            }
        },[])
        

        useEffect(()=>{
            $(".gp_upload_copy").hide()
        },[])

        const clusterData = selectionOnwedAlbumsRes ? selectionOnwedAlbumsRes : selectionSharedAlbumsRes
        let albumsListData;
        if(selectionSharedAlbumsRes){
            albumsListData= prepareMonthWiseMySharedAlbumsList(clusterData);
        }else{
            albumsListData= prepareMonthWiseAlbumList(clusterData.clusters);
        }
        console.log("albumsListData=",albumsListData);
        var eachMonthGrids = [];
        
        const [ref,setRef] = useScrollRef(clusterData);
        console.log(ref);
        for (const key in albumsListData) {
            const val = albumsListData[key];
            console.log("for key",key," and value=",val)
            let albumCreateDate = [];
            let date,year = key;
            albumCreateDate = key.split("_");
            date = photoOrg.config.months[albumCreateDate[0]]
            year = albumCreateDate[1];

            eachMonthGrids.push(
                <li key={key} id={key} className='asset-group'>
                    <div className="monthbar">
                        <div className="left">
                            <h2>{date} {year}</h2>
                        </div>
                    </div>
                    
                    {
                        val.map(item => {
                            let albumModel = selectionSharedAlbumsRes ? item :  item['album'];
                            let foundAlbum = false;
                            if (photoOrg.selectedAlbumId && albumModel.id === photoOrg.selectedAlbumId) {
                                photoOrg.foundAlbum = true;
                                foundAlbum = true;
                            }
                            const props = {albumModel: {...albumModel,imagesCount:(item.photoCount || item.imagesCount),dontShowImagesCount:false},foundRef: foundAlbum,setRef:setRef, accessType: accessType, container_key:key, albumThumnailSize:getAlbumThumnailSize(),inlineIngestionFlow:false, currentPageno: currentPageno}
                            return <PrepareIndividualAlbum rid="PrepareIndividualAlbum" key={albumModel.albumId || albumModel.id} {...props}/>
                        })
                    }
                    
                </li>)
        }
        return (
            <>
                {eachMonthGrids}
            </>
        )
    }catch(e){
        photoOrg.clientLogger.error({description: "LIBRARY:OwnedAlbumsView:IterateAndGenerateAlbumDom:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
    }

}

IterateAndGenerateAlbumDom.propTypes = {
    selectionwedAlbumsRes: PropTypes.shape({
        clusters: PropTypes.object,
        pages: PropTypes.array
    })
};

export default IterateAndGenerateAlbumDom;